import axios from 'axios'

import config from '../../config'

const createSafetyItemUniqueValue = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/SafetyItemUniqueValues`
  return axios.post(url, data)
}

export default createSafetyItemUniqueValue
